var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._g({class:[
      'v-contact-widget__icon',
      'text-primary' ]},_vm.$listeners),[_c('v-icon',{attrs:{"width":"20","name":"phone"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }